<template>
  <div>
    <OdontogramItem :item="item" />
  </div>
</template>

<script>
import OdontogramItem from '../item/OdontogramItem.vue';

export default {
  props: ['data'],
  components: {
    OdontogramItem,
  },
  computed: {
    item() {
      return {
        ...this.data,
        anamnesis: {
          ...this.data.anamnesis,
          inputs: Array.isArray(this.data.anamnesis.inputs)
            ? this.data.anamnesis.inputs.reduce((acc, input) => {
              acc[input.name] = input.value;
              return acc;
            }, {})
            : this.data.anamnesis.inputs,
        },
      };
    },
  },
};
</script>
